import { render } from "./SurveyCheckbox.vue?vue&type=template&id=ef4a3532&scoped=true"
import script from "./SurveyCheckbox.vue?vue&type=script&lang=js"
export * from "./SurveyCheckbox.vue?vue&type=script&lang=js"

import "./SurveyCheckbox.vue?vue&type=style&index=0&id=ef4a3532&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ef4a3532"

export default script